import { AbstractRenderer, BoxModelConstraint, BoxModelContext, ContentBox, SVGUtils, TextSvgRendererUtils } from '@blk/simba';

export enum HeadingLevel {
	H1,
	H2,
	H3,
	H4,
	H5
}

export class HeadingComponent extends AbstractRenderer<SVGGElement> {
	private readonly fill = '#000';
	public height: number;
	public width: number;
	public availWidth: number;
	public availHeight: number;
	public headingAttributes: Object;
	public headingTemplate: string;
	public componentTemplate: SVGGElement;

	private sectionH1Attrs = {
		'font-family': 'FortExtraBold',
		'font-size': '24',
		'font-weight': '600',
		fill: this.fill
	};

	private sectionH2Attrs = {
		'font-family': 'FortExtraBold',
		'font-size': '14',
		'font-weight': '600',
		fill: this.fill
	};

	private sectionH3Attrs = {
		'font-family': 'FortBold',
		'font-size': '9',
		'font-weight': '600',
		fill: this.fill
	};

	private sectionH4Attrs = {
		'font-family': 'FortBook',
		'font-size': '10',
		fill: this.fill
	};

	private sectionH5Attrs = {
		'font-family': 'FortBold',
		'font-size': '10',
		fill: this.fill
	};

	constructor(private dcrKey: string, private name: string, public level: HeadingLevel, public constraints?: Partial<BoxModelConstraint>) {
		super(BoxModelConstraint.merge({ paddingBottom: 5, paddingTop: 5 }, constraints));
		this.setupHeadingLevel();
	}

	protected renderContent(context: BoxModelContext): ContentBox<SVGGElement> {
		const widthConstraint: number = context.availableWidth;
		const heightConstraint: number = context.availableHeight;
		const textBox: ContentBox<SVGGElement> = TextSvgRendererUtils.generateWithHTML(
			this.dcrKey ? this.contentProvider.get(this.dcrKey, this.name) : this.name,
			this.headingAttributes,
			widthConstraint,
			heightConstraint,
			0
		);
		const titleTextNodeList: NodeListOf<SVGTextElement> = textBox.element.querySelectorAll('text');
		for (const key in this.headingAttributes) {
			if (this.headingAttributes.hasOwnProperty(key)) {
				Array.from(titleTextNodeList).forEach(textElement => {
					textElement.setAttribute(key, this.headingAttributes[key]);
				});
			}
		}
		// Are changes in titleTextNodeList reflected in textBox?

		SVGUtils.setupEditMode(textBox, this.dcrKey, this.name, this.contentProvider);
		return textBox;
	}

	private setupHeadingLevel(): void {
		switch (this.level) {
			case HeadingLevel.H1:
				this.height = 35;
				this.headingAttributes = this.sectionH1Attrs;
				break;
			case HeadingLevel.H2:
				this.height = 30;
				this.headingAttributes = this.sectionH2Attrs;
				break;
			case HeadingLevel.H3:
				this.height = 30;
				this.headingAttributes = this.sectionH3Attrs;
				break;
			case HeadingLevel.H4:
				this.height = 50;
				this.headingAttributes = this.sectionH4Attrs;
				break;
			case HeadingLevel.H5:
				this.height = 15;
				this.headingAttributes = this.sectionH5Attrs;
				break;
		}
	}
}
